module.exports = __webpack_public_path__ + "science.96221fb1bf2adb77d14b.woff";


//////////////////
// WEBPACK FOOTER
// C:/Users/INMOGR/Desktop/Angular Project/src/assets/fonts/line-icons-pro/science/webfont/science.woff
// module id = ../../../../../src/assets/fonts/line-icons-pro/science/webfont/science.woff
// module chunks = styles